import { gql } from "apollo-angular";

export const UpdateUser = gql`
  mutation UpdateUserGQL($data: UpdateUser!) {
    updateUser(data: $data) {
      id
    }
  }
`;